import { Environment, baseEnvironment } from './base';

export const environment: Environment = {
  ...baseEnvironment,
  apiBasePath: 'https://apitest.renaultbank.es',
  applications: {
    home: 'https://test.renaultbank.es',
    onboarding: 'https://registrotest.renaultbank.es',
    documents: 'https://doctest.renaultbank.es',
  },
  authorization: 'eFh0WmxLNU03bXlRVWtwcWNaakk6RUNVaWxyREduUXRpWGhFQ1lZWTM=',
  firebaseAnalyticsDebugMode: true,
  chatbot: {
    siteURL: 'https://renaultbank--uatfull.sandbox.my.site.com/ESWRCIWEBCHAT1741103457124',
    orgIdSF: '00D2z000000658C',
    sdkURL: 'https://renaultbank--uatfull.sandbox.my.site.com/ESWRCIWEBCHAT1741103457124/assets/js/bootstrap.min.js',
    scrt2URL: 'https://renaultbank--uatfull.sandbox.my.salesforce-scrt.com',
    typeChat: 'RCI_WEB_CHAT'
  },
};
